// export let applicationName = "/pepcoWeb/"
export let applicationName = "/pepco"
export let loadingTime = 8000